import * as Phaser from 'phaser';
import { BootScene } from './scenes/BootScene.ts';
import { BoatScene } from './scenes/BoatScene.ts';
import { BotScene } from './scenes/BotScene.ts';
import { EditorScene } from './scenes/EditorScene.ts';
import { GameScene } from './scenes/GameScene.ts';
import { StartScene } from './scenes/StartScene.ts';
import { RENDER_FLAGS } from './renderFlags.ts';
import { loadRenderSettings } from '../ui/settingsStore.ts';

export function createGameConfig(): Phaser.Types.Core.GameConfig {
  return {
    type: Phaser.AUTO,
    parent: 'game-container',
    backgroundColor: '#0b1d2a',
    render: {
      // Canvas MSAA: the player's Smooth edges setting (pause menu), or `?aa=0` for the GPU
      // A/B in docs/PERFORMANCE.md. Texture filtering (`antialias`) stays linear so the
      // hull sprite is unaffected either way.
      antialiasGL: RENDER_FLAGS.antialias && loadRenderSettings().smoothEdges,
    },
    scale: {
      mode: Phaser.Scale.RESIZE,
      width: '100%',
      height: '100%',
    },
    input: {
      // Mouse + two touch pointers so a pinch has a slot for each finger.
      activePointers: 3,
    },
    scene: [BootScene, StartScene, GameScene, EditorScene, BoatScene, BotScene],
  };
}
